<script lang="ts">
	import { onMount } from 'svelte';
	import { getProjectAvatar } from '$lib/locations';

	export let image_url: string | undefined;
	export let alt = '...';
	export let loading = false;
	let src;
	const imgClass = `w-full h-full object-cover bg-cosmicPurple800 bg-opacity-50 bg-opacity-100`;

	const updateSrc = async () => {
		loading = true;
		src = await getProjectAvatar(image_url);
		// there is some conflict in either here or in avatarProject where the recently added image_url is showing in prev added item. it fixes itself on page reload. It only happens when entering more than one project at a time
		loading = false;
		// console.log(src);
	};

	// this is pulling the image_url of the last loaded page, if user goes to Find Blooms and clicks on one location, then back to Find Blooms and clicks on another location - it's not updating to the correct location record
	onMount(() => {
		updateSrc();
		// console.log('image_url, ', image_url);
	});
</script>

<div class="avatar relative">
	<div class="block hover:opacity-80 mx-auto">
		<img class={imgClass} {src} {alt} />
	</div>
	<!-- **this should only show if we are in the add project screen** -->
</div>
